import { setStorage, getStorageSync } from '@/utils/storage'
import {
  STORAGE_FLIGHTS_QUERY_TC,
} from '@/utils/train-storage'
import { trackEvent } from '@/common/track'

function formatAirPortData(_airports) {
  return _airports.map(({
    cityCode,
    cityName,
    airportCode,
    airportName,
    type,
    airports,
  }) => ({
    city_id: cityCode,
    city_name: cityName,
    id: airportCode,
    name: airportName,
    type: type || 0,
    station_list: (airports || []).map(({airportName, airportCode}) => ({
      name: airportName,
      id: airportCode,
      type: 2, // 2国内机场 0国内城市
    }))
  }))
}

export default {
  setQueryCardBtnText(state, payload = '') {
    state.queryCardBtnText = payload
  },
  setFlightsQuery(state, payload = {}) {
    const ret = {
      ...state.flightsQuery,
      ...payload,
    }
    state.flightsQuery = ret
    setStorage({ key: STORAGE_FLIGHTS_QUERY_TC, data: ret })
  },
  updateFlightsQuery(state) {
    const currentStorageQuery = getStorageSync(STORAGE_FLIGHTS_QUERY_TC)
    this.setFlightsQuery(state, currentStorageQuery)
  },
  setAllFlightsCityList(state, payload = {}) {
    const { citys = {}, hotCitys = [] } = payload
    state.flightsCities = Object.keys(citys).reduce((ret, k) => {
      return ret.concat({
        first_upper_letter: k,
        city_list: citys[k].map(({cityCode, cityName}) => ({
          city_id: cityCode,
          city_name: cityName,
        }))
      })
    }, [])
    state.flightsHotCities = hotCitys.map(({cityCode, cityName}) => ({
      city_id: cityCode,
      city_name: cityName,
    }))
  },
  setSearchList(state, payload = {}) {
    const { airports = [], cityAirports = [] } = payload
    state.cityAirports = formatAirPortData(cityAirports)
    state.airports = formatAirPortData(airports)
  },
  setPrivacyList(state, payload = {}) {
    state.privacyList = payload
  },
  showPrivacyPopup(state, payload = {}) {
    state.privacyVisible = true
    state.privacyCb = payload.cb
  },
  onPrivacyVerify(state, payload = {}) {
    state.privacyVisible = false
    const { detail } = payload
    trackEvent('yks_plane_home_agreement_ck', '迎客松-机票-首页-服务协议-点击', {
      button: detail ? 'agree' : 'refuse'
    })
    if(detail) {
      state.privacyList = {}
      state.privacyCb && state.privacyCb()
    }
  },
  setFlightsCouponData(state, payload) {
    state.flightsCouponData = payload;
    console.log('setFlightsCouponData', state.flightsCouponData);
  },
}
